<template>
  <section>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <br />
    <div class="box is-paddingless is-light wdt">
      <!-- <div class="shdw is-paddingless wdt ubuntu" style=""> -->
      <div class="tile is-parent is-vertical centered field">
        <div class="image">
          <!-- <p class="krungthrep" style="text-align: center;">
            <span class="trip">Trip </span> <span class="circuit">Circuit</span>
          </p> -->
          <img src="images/TC wired for Gant Travel.png" />
        </div>
        <br />
        <b-field placeholder="Email">
          <b-input
            v-model="email"
            @keyup.native.enter="submitForm"
            placeholder="Email"
            name="email"
            data-test="email_input"
          ></b-input>
        </b-field>
        <b-field>
          <b-input
            type="password"
            v-model="password"
            @keyup.native.enter="submitForm"
            placeholder="Password"
            name="password"
            data-test="password_input"
          >
          </b-input>
        </b-field>
        <b-message
          v-if="error"
          type="is-danger"
          aria-close-label="Close message"
          data-test="error_message"
        >
          {{ errorMsg }}
        </b-message>
        <b-button
          size="is-medium"
          type="is-gant"
          class="ubuntu"
          @click="submitForm"
          data-test="login_button"
          expanded
        >
          <h5>Login</h5>
        </b-button>
        <div class="my-4">
          <p class="text-center register ubuntu">
            <a
              @click="goToSsoPage"
              id="signup"
              class="teal-text"
              >Log in with SSO</a
            >
          </p>
        </div>
        <div class="my-4">
          <p class="text-center register ubuntu">
            Don't have an account yet?
            <a
              :href="this.$appConfig.gantGatewayUrl + '/user/register'"
              id="signup"
              class="teal-text"
              >Register Now</a
            >
          </p>
        </div>
        <div class="conditions">
          <p class="text-center ubuntu">
            By signing in, you agree to the
            <a
              id="termsAndConditions"
              class="teal-text"
              :href="this.$appConfig.gantGatewayUrl + '/terms-and-conditions'"
              >Terms and Conditions</a
            >
          </p>
        </div>
        <br />
      </div>
    </div>
    <br />
  </section>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      logged_in: false,
      email: "",
      password: "",
      access_token: "",
      error: false,
      errorMsg: "Login Failed",
      loading: false,
    };
  },
  computed: {},
  methods: {
    goToSsoPage() {
      this.$router.push({ path: "/sso" });
    },
    /* Submit form, verify credentials and get Oauth token */
    async submitForm() {
      let url = process.env.VUE_APP_HUDDLELABS_API_BASE_URL + "oauth/token";
      // Populate the form data
      var data = new FormData();
      data.append("grant_type", process.env.VUE_APP_GANT_GATEWAY_GRANT_TYPE);
      data.append("client_id", process.env.VUE_APP_GANT_GATEWAY_CLIENT_ID);
      data.append(
        "client_secret",
        process.env.VUE_APP_GANT_GATEWAY_CLIENT_SECRET
      );
      data.append("scope", process.env.VUE_APP_GANT_GATEWAY_SCOPE);
      data.append("username", this.email);
      data.append("password", this.password);

      var requestOptions = {
        method: "POST",
        body: data,
        redirect: "follow",
      };

      let response = await fetch(url, requestOptions);
      let result = await response.json();

      if (result.access_token) {
        this.access_token = result.access_token;
        this.signIn();
      } else {
        this.error = true;
        this.errorMsg = "Invalid username or password";
      }
    },

    async signIn() {
      const logOutTime = this.$appConfig.routerTimer;
      if (this.access_token) {
        let date = new Date().getTime() + logOutTime;
        this.loading = true;

        // Use this.access_token to retrieve profile for the verified user
        let myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + this.access_token);
        myHeaders.append("Accept", "application/json");

        let url = process.env.VUE_APP_HUDDLELABS_API_BASE_URL + "get-profile";
        let body = {
          method: "POST",
          headers: myHeaders,
          redirect: "error",
        };

        let response = await fetch(url, body);
        if (response.ok) {
          let result = await response.json();
          console.log("login success");
          this.$store.dispatch("travellersAndTrips/addProfile", result.data);
          this.$store.dispatch("app/addToken", this.access_token);
          //localStorage.setItem("isAuthenticated", true);
          //localStorage.setItem("expireTime", date);
          this.$store.dispatch("app/getCurrentAppVersion"); // make API call to get current app version

          let travellers = {
            tripType: "business",
            bookFor: "user",
            others: [],
            set: true,
            business: true,
            self: true,
          };
          this.$store.commit("travellersAndTrips/EDIT_TRAVELLERS", travellers);
          if (this.$route.name == "Meetings") {
            this.$nav.pushRouteTo({
              path: this.$route.path + "/authorization",
              query: this.$route.query,
            });

            this.initializeTracking();
          } else {
            this.$nav.pushRouteTo({ name: "home" });
          }
        } else {
          this.error = true;
          this.errorMsg = "Unable to find user profile";
        }

        this.loading = false;
      } else {
        this.error = true;
        this.errorMsg = "Unable to verify login credentials";
      }
    },

    /* Verify provided access token is valid (SSO login only) */
    async checkAccessToken(accessToken) {
      let url = process.env.VUE_APP_HUDDLELABS_API_BASE_URL + "validate-token";
      let myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + accessToken);
      myHeaders.append("Accept", "application/json");

      let requestOptions = {
        method: "HEAD",
        headers: myHeaders,
        redirect: "error",
      };

      // If the request succeeds, the access token is valid
      let response = await fetch(url, requestOptions);
      if (response.ok) {
        this.access_token = accessToken;
        this.signIn();
      } else {
        this.error = true;
        this.errorMsg = "SSO login failed.";
      }

      /*
      await fetch(url, requestOptions)
        .then((response) => response.ok)
        .then((resultOK) => {
          if (resultOK) this.access_token = accessToken;
          this.signIn();
        })
        .catch((error) => {
          console.log("error", error);
          this.error = true;
          this.errorMsg = "SSO login failed.";
        });

        */
    },

    initializeTracking() {
      var travelProfile = this.$store.getters["app/getActiveUser"];

      var pendoUser = {
        visitor: {
          id: travelProfile.email,
          sf_contact_id: travelProfile.id,
          email: travelProfile.email,
          first_name: travelProfile.firstName,
          last_name: travelProfile.lastName,
          traveler_persona: travelProfile.travelerPersona,
          is_vip: travelProfile.isVip,
          is_guest: travelProfile.isGuest,
          is_travel_champion: travelProfile.isTravelChampion,
        },
        account: {
          id: travelProfile.account.name,
          sf_account_id: travelProfile.account.id,
          gant_account_number: travelProfile.account.gantAccountNumber,
          name: travelProfile.account.name,
        },
      };

      // in your authentication promise handler or callback
      if (this.$appConfig.amadeusEnvironment == "production") {
        window.pendo.initialize(pendoUser);
      } else {
        //// console.log('Pendo tracking not enabled in this environment')
        //// console.log(pendoUser)
      }
    },

    async getCodeConverter() {
      // Get list of vendors
      this.$app.huddleLabsServerCall("resources/vendors").then((result) => {
        // // console.log(result);
        this.$store.dispatch("bookTravel/vendors", result);
      });

      // Get list of airports
      this.$app.huddleLabsServerCall("resources/airports").then((result) => {
        let airports = result.data;
        // // console.log(airports);
        this.$store.dispatch("bookTravel/airports", airports);
      });

      // Get details about airline unaccompanied minors programs
      this.$app
        .huddleLabsServerCall("resources/airline-unaccompanied-minors")
        .then((result) => {
          let details = result.data;
          // // console.log('unaccompanied minors programs', details)
          this.$store.dispatch(
            "travellersAndTrips/unaccompaniedMinorAirlineDetails",
            details
          );
        });
    },

    formatTickets(tickets) {
      var airlineCodes = [];
      var ticket;
      if (tickets) {
        for (ticket of tickets) {
          if (!airlineCodes.includes(ticket.airlineCode)) {
            airlineCodes.push(ticket.airlineCode);
          }
        }
      }
      return {
        airlines: airlineCodes,
        tickets: tickets,
      };
    },
  },

  mounted() {
    //this.$app.logout();

    // SSO Login - convert SSO token to HuddleLabs access token
    // Check for token in the URL parameter and convert to usable access_token
    var ssoToken = this.$route.query.token;
    if (ssoToken) {
      // Set the secret key/salt to remove from the start of the token
      var tokenSalt = process.env.VUE_APP_TRIPCIRCUIT_SSO_SALT;

      // base64_decode the token
      var decoded = atob(ssoToken);

      // Remove the secret key/salt to leave only the real access token
      var accessToken = decoded.replace(tokenSalt, "");

      // Check if the access token is valid
      this.checkAccessToken(accessToken);
    }
    this.getCodeConverter();
  },
};
</script>

<style scoped>
.image {
  padding: 15px;
  padding-right: 20px;
}

.trip {
  color: #292c58;
  font-family: Krungthep;
  font-size: 50px;
}

.circuit {
  color: #00aa9c;
  font-family: Krungthep;
  font-size: 50px;
}

.text-center {
  text-align: center;
}

.centered {
  margin: auto;
}

.field {
  border-radius: 5px;
}

.wdt {
  width: 500px;
  margin: auto;
  /* background-color: #F5F0E1; */
}

.register {
  background-color: #ddd;
  /* background-color: #F5F0E1; */
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.conditions {
  font-size: 13px;
  color: #292c58;
}

.btn {
  background-color: #292c58;
}

.shdw {
  box-shadow: 0 2px 4px 0 rgba(245, 240, 225, 0.8),
    0 6px 20px 0 rgba(245, 240, 225, 0.8);
  border-radius: 5px;
}

.fade {
  opacity: 0.5;
  transition: opacity 0.05s ease-in-out;
  -moz-transition: opacity 0.05s ease-in-out;
  -webkit-transition: opacity 0.05s ease-in-out;
}

.fade:hover {
  opacity: 1;
}

@media screen and (max-width: 1023px) {
  .wdt {
    width: 100%;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}

@media screen and (min-width: 1024px) {
  .wdt {
    width: 500px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
</style>
